import { keepPreviousData } from "@tanstack/react-query";
import { useFeeChargeBreakdownTableProps } from "features/fees/FeeChargeBreakdownTableProps";
import { PostedFeeChargeOutletContext } from "features/fees/posted/PostedFeeChargeOutletContext";
import { aggFuncForFeesBreakdown } from "features/fees/posted/PostedFeeChargeUtils";
import { useFeeChargeEventPeriodBreakdownTableDataRetrieve } from "gen/endpoints/fee-charge-event/fee-charge-event";
import React from "react";
import { useOutletContext } from "react-router";
import { LoadingState } from "shared/components/empty/LoadingState";
import { DataTable } from "shared/components/table/data/DataTable";

export const PostedFeeChargeBreakdownTab: React.FC = () => {
  const { fundFamilyId, feeChargeEventId, isEqualizedView } =
    useOutletContext<PostedFeeChargeOutletContext>();
  const { data } = useFeeChargeEventPeriodBreakdownTableDataRetrieve(
    fundFamilyId,
    feeChargeEventId,
    {
      is_equalized_view: isEqualizedView || undefined,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );
  const tableProps = useFeeChargeBreakdownTableProps(fundFamilyId);
  return data ? (
    <DataTable data={data} aggFunc={aggFuncForFeesBreakdown} {...tableProps} />
  ) : (
    <LoadingState />
  );
};
